
export default {
  name: 'SkeletonProductResult',

  props: {
    counts: { type: Number, default: 45 },
    view: { type: String, default: 'grid' },
  },
}
